// import { Component } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/shared/data/data.service';
@Component({
  selector: 'app-order-summery',
  templateUrl: './order-summery.component.html',
  styleUrl: './order-summery.component.scss'
})
export class OrderSummeryComponent {
  orders: any[] = [];
  customerName = localStorage.getItem('customer_name');
  selectedOrder: any = null;
  showTrackingModal = false;

  currentPage = 1;
  pageSize = 5;

  constructor(private http: HttpClient , public data: DataService) {}

  ngOnInit(): void {
    this.loadOrders();
  }

  loadOrders() {
    const payload = {
      customer_id: localStorage.getItem('customer_id')
    };

    this.http.post<any[]>(this.data.base_url + 'get_my_orders/', payload)
      .subscribe(res => {
        this.orders = res.map(o => ({ ...o, open: false }));
        this.currentPage = 1;
      });
  }

  get paginatedOrders() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    return this.orders.slice(startIndex, startIndex + this.pageSize);
  }

  get totalPages() {
    return Math.ceil(this.orders.length / this.pageSize);
  }

  get pagesArray() {
    return Array(this.totalPages).fill(0).map((_, i) => i + 1);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  setPage(page: number) {
    this.currentPage = page;
  }

  downloadInvoice(orderId: number): void {
    this.http.get(
      this.data.base_url + 'download_invoice/' + orderId + '/',
      {
        responseType: 'blob'
      }
    ).subscribe({
      next: (response: Blob) => {
        const blob = new Blob(
          [response],
          {
            type: 'application/pdf'
          }
        );
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `invoice_${orderId}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error(
          'Invoice download failed',
          err
        );
      }
    });
  }

  openTracking(order: any) {
    this.selectedOrder = order;
    this.showTrackingModal = true;
  }

  closeTracking() {
    this.showTrackingModal = false;
    this.selectedOrder = null;
  }
}
